import { Box } from "@mui/material";
import Image from "next/image";
import React from "react";

const ObjectIconImg = (props) => {
  function GetUserImg(name) {
    if (name) {
      let arr = name?.split(" ");
      if (arr.length > 1) {
        return (
          arr[0]?.toUpperCase()?.substring(0, 1) +
          arr[1]?.toUpperCase()?.substring(0, 1)
        );
      } else {
        return arr[0]?.toUpperCase()?.substring(0, 2);
      }
    }
    return "";
  }
  const { innerClass, outerClass, profilePic, name } = props;
  return (
    <Box
      className={outerClass ? outerClass : "usr-icon"}
      component="div"
      sx={{
        backgroundColor: props?.backgroundColor ? props?.backgroundColor : "",
      }}
    >
      {profilePic && (
        <div className={innerClass ? innerClass : "obj_img"}>
          <Image alt="" src={profilePic} layout="fill" />
        </div>
      )}
      {!profilePic && (
        <div className={innerClass ? innerClass : "obj_img"}>
          {GetUserImg(name)}
        </div>
      )}
    </Box>
  );
};

export default ObjectIconImg;
